import { render, staticRenderFns } from "./EditBroker.vue?vue&type=template&id=4404e26c&scoped=true&"
import script from "./EditBroker.vue?vue&type=script&lang=js&"
export * from "./EditBroker.vue?vue&type=script&lang=js&"
import style0 from "./EditBroker.vue?vue&type=style&index=0&id=4404e26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404e26c",
  null
  
)

export default component.exports